var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    {
      staticClass: "card-box",
      style: { marginBottom: "24px" },
      attrs: { bordered: false },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.name + "【情绪趋势分析】") + "\n    "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              !_vm.hiddenCompare
                ? _c(
                    "a-button",
                    {
                      staticClass: "custom-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.addCompareData },
                    },
                    [_vm._v("\n        添加对比\n      ")]
                  )
                : _vm._e(),
              _c(
                "a-button",
                {
                  staticClass: "custom-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.showLineDetail },
                },
                [_vm._v("查看档案")]
              ),
              _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "has",
                      rawName: "v-has",
                      value: "studentPic:show",
                      expression: "'studentPic:show'",
                    },
                  ],
                  staticClass: "custom-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.showImgDetail },
                },
                [_vm._v("\n        查看照片\n      ")]
              ),
              _c(
                "a-button",
                {
                  staticClass: "custom-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.addEventClick },
                },
                [_vm._v("添加事件")]
              ),
              _c("a-icon", {
                staticClass: "delete-icon",
                style: { fontSize: "18px", color: "#ccc" },
                attrs: { type: "close" },
                on: { click: _vm.deleteRecord },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "salesCard" },
        [
          _c("LineChart", {
            key: _vm.studentInfo.studentId,
            attrs: {
              height: "220px",
              fields: _vm.moodField,
              dataSource: _vm.dataSource,
              color: ["#EE6666", "#657ECB", "#9DD184", "#FBCF6C"],
              showBottomMark: "",
              showBottomExpandArea: "",
              attrs: _vm.studentInfo,
            },
          }),
        ],
        1
      ),
      _c("ViewKeyPointModal", { ref: "viewKeyPointModal" }),
      _c("AddEventModal", {
        ref: "addEventModal",
        on: { refresh: _vm.refreshMarked },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }